import React, { Component } from 'react'
import SVG from 'react-inlinesvg'

require('./avatar.scss')

export default class Avatar extends Component {
  render() {
    const styleKey = this.props.nickname

    return (
      <div className="avatar-container">
        <style
          dangerouslySetInnerHTML={{
            __html: `
        .${styleKey} svg path {
          fill: ${this.props.color};
        }
      `,
          }}
        />

        <SVG src={this.props.image} className={`avatar-image ${styleKey}`} cacheGetRequests={true} />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/avatar/Avatar.jsx